module.exports = __webpack_public_path__ + "img/flecha-volver_2.5a1c1218.svg";